import * as React from 'react';
import DeltaNav from './nav/DeltaNav';
import DataContent from './sections/DataContent';
import { DeltaSelect } from '../../../../store/action/deltaActions';
import {
    ANALYSTS, DATA, ENTERPRISE, LEADERSHIP, TARGET, TECHNIQUES, TECHNOLOGY
} from '../../../../store/constants';
import { dataMessage, dataQuestions } from './data/dataQuestions';
import { enterpriseMessage, enterpriseQuestions } from './data/enterpriseData';
import { leadershipMessage, leadershipQuestions } from './data/leadershipQuestions';

import { targetsMessage, targetsQuestions } from './data/targetsQuestion';
import { analystsMessage, analystsQuestions } from './data/analystsQuestions';
import { technologyMessage, technologyQuestions } from './data/technologyQuestions';
import { techniquesMessage, techniquesQuestions } from './data/techniquesData';
import { SelectedOptions } from '../../../../store/reducers/deltaReducer';

interface Props {
    onChange: DeltaSelect;
    activePanel: string;
    selectedOptions: SelectedOptions;
}

class DeltaContent extends React.Component<Props> {
    render() {
        const { onChange, activePanel, selectedOptions } = this.props;

        return (
            <div>
                <DeltaNav activePanel={activePanel} />
                { activePanel === DATA &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={DATA}
                        message={dataMessage}
                        selectedOptionId={selectedOptions.DATA}
                        questions={dataQuestions}
                    />
                }
                { activePanel === ENTERPRISE &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={ENTERPRISE}
                        message={enterpriseMessage}
                        selectedOptionId={selectedOptions.ENTERPRISE}
                        questions={enterpriseQuestions}
                    />
                }
                { activePanel === LEADERSHIP &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={LEADERSHIP}
                        message={leadershipMessage}
                        selectedOptionId={selectedOptions.LEADERSHIP}
                        questions={leadershipQuestions}
                    />
                }
                { activePanel === TARGET &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={TARGET}
                        message={targetsMessage}
                        selectedOptionId={selectedOptions.TARGET}
                        questions={targetsQuestions}
                    />
                }
                { activePanel === ANALYSTS &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={ANALYSTS}
                        message={analystsMessage}
                        selectedOptionId={selectedOptions.ANALYSTS}
                        questions={analystsQuestions}
                    />
                }
                { activePanel === TECHNOLOGY &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={TECHNOLOGY}
                        message={technologyMessage}
                        selectedOptionId={selectedOptions.TECHNOLOGY}
                        questions={technologyQuestions}
                    />
                }
                { activePanel === TECHNIQUES &&
                    <DataContent
                        onChange={onChange}
                        deltaPanelId={TECHNIQUES}
                        message={techniquesMessage}
                        selectedOptionId={selectedOptions.TECHNIQUES}
                        questions={techniquesQuestions}
                    />
                }
            </div>
        );
    }
}

export default DeltaContent;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/DeltaContent.tsx